import { render, staticRenderFns } from "./ReceiptSettings.vue?vue&type=template&id=51c72800&scoped=true"
import script from "./ReceiptSettings.vue?vue&type=script&lang=js"
export * from "./ReceiptSettings.vue?vue&type=script&lang=js"
import style0 from "./ReceiptSettings.vue?vue&type=style&index=0&id=51c72800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c72800",
  null
  
)

export default component.exports